module.exports = new __parcel__URL__("arrow-up-left.ae958530.svg").toString();